module.exports = __webpack_public_path__ + "img/alturos-destinations-logo-2023-black.eb6a1eec.png";